import { ArrowLeftIcon } from "lucide-react";
import { Link } from "react-router-dom";
import AuthLayout from "@container/layout/auth";
import WorkspaceCompanyForm from "@container/workspace-company-form";

export function WorkspaceEditPage() {
    return (
        <AuthLayout withoutHeader>
            <div className="min-h-screen">
                {/* Header */}
                <div className="mb-8">
                    <div className="flex items-center gap-4 mb-4">
                        <Link
                            to="/workspaces"
                            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
                        >
                            <ArrowLeftIcon className="h-5 w-5" />

                            <span>Back to Workspaces</span>
                        </Link>
                    </div>
                    <h1 className="text-3xl font-bold text-gray-900">
                        Edit Company Workspace
                    </h1>
                </div>

                <WorkspaceCompanyForm isEditMode />
            </div>
        </AuthLayout>
    );
}
